import { TeilnehmerVO } from "@core/api/v1";
import FachrichtungenEnum = TeilnehmerVO.FachrichtungenEnum;

export const fachrichtungOptionen: { label: string, value: FachrichtungenEnum }[] = [
    {label: 'Keine', value: FachrichtungenEnum.KEINE },
    {label: 'Allgemeinmedizin', value: FachrichtungenEnum.ALLGEMEINMEDIZIN },
    {label: 'Innere Medizin', value: FachrichtungenEnum.INNEREMEDIZIN },
    {label: 'Neurologie', value: FachrichtungenEnum.NEUROLOGIE },
    {label: 'Orthopädie', value: FachrichtungenEnum.ORTHOPAEDIE },
    {label: 'Psychatrie', value: FachrichtungenEnum.PSYCHIATRIE },
    {label: 'Sonstige Fachrichtung', value: FachrichtungenEnum.SONSTIGEFACHRICHTUNG }
];
